// extracted by mini-css-extract-plugin
export default {"error-container":"LocalErrorDisplay_error-container__z-l3l","error-text-container":"LocalErrorDisplay_error-text-container__a9WxT"};